var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlternativenamesgradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 17 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: url(#linear-gradient-3);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5.5,
    y1: 6,
    x2: 13.5,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3aecfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d9bf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    x2: 7.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 12.5,
    x2: 17,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.5.5h4M9.5.5h4M9.5.5v11M9.5,11.5h-4M9.5,11.5h4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.5,3.5H2.06c-.86,0-1.56.75-1.56,1.67v3.33h7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.5,8.5h2.4c.88,0,1.6-.75,1.6-1.67v-3.33h-4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlternativenamesgradient);
export default __webpack_public_path__ + "static/media/Alternative names gradient.6aab1a54bef0b76fddf438f27957c881.svg";
export { ForwardRef as ReactComponent };